import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import DeleteIcon from '@mui/icons-material/Delete';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/system';
import React, { useContext } from 'react';
import { useCol } from '../hooks/firebase';
import { FieldContext } from '../App';

export const FieldRequest = ({ setSelectedTab }) => {
    const { data, loading, deleteRecord } = useCol('collaborateRequest');
    const { setOwnerId } = useContext(FieldContext);

    const deleteFunc = async (id) => {
        try {
            await deleteRecord(id);
        } catch (err) {
            console.error(err);
        }
    };
    const onClick = (id) => {
        setOwnerId(id);
        setSelectedTab('Add-field');
    };

    if (loading) return <div>Loading...</div>;

    console.log(data);

    return (
        <Box
            overflow="scroll"
            fullWidth
            height="84vh"
            className="detail-container"
            p={3}
        >
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Заалны нэр</TableCell>
                            <TableCell align="right">Дэлгэрэнгүй</TableCell>
                            <TableCell align="right">Байршил</TableCell>
                            <TableCell align="right">
                                Холбогдох дугаар
                            </TableCell>
                            <TableCell align="right">Устгах</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((cur, index) => (
                            <RequestItem
                                {...cur}
                                key={`request-${index}`}
                                onClick={() => onClick(cur.userId)}
                                deleteFunc={() => deleteFunc(cur.id)}
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

const RequestItem = ({
    name,
    description,
    location,
    phoneNumber,
    deleteFunc,
    onClick,
}) => {
    console.log(name)
    return (
        <TableRow
            sx={{
                '&:last-child td, &:last-child th': {
                    border: 0,
                },
                cursor: 'pointer',
            }}
            onClick={onClick}
        >
            <TableCell component="th" scope="row">
                {name}
            </TableCell>
            <TableCell align="right">{description}</TableCell>
            <TableCell align="right">{location}</TableCell>
            <TableCell align="right">{phoneNumber}</TableCell>
            <TableCell align="right">
                <DeleteIcon onClick={deleteFunc} sx={{ cursor: 'pointer' }} />
            </TableCell>
        </TableRow>
    );
};
